// extracted by mini-css-extract-plugin
export default {"newArrivalsList":"NewArrivals_newArrivalsList__wuzA8","newArrivalsLineBottom":"NewArrivals_newArrivalsLineBottom__riYMK","buttonWrap":"NewArrivals_buttonWrap__Q3IlK"};